module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Ki-La.3332ded6.png";